export default () => {
  return {
    getMegapixels: async(file) => {
      if (!file || !file.type.includes('image')) {
        return 0;
      }

      return await new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = (event) => {
          const img = new Image();

          img.onload = () => {
            const { naturalWidth, naturalHeight } = img;
            const totalPixels = naturalWidth * naturalHeight;

            resolve(totalPixels / 1000000);
          };

          img.onerror = () => resolve(0);

          img.src = event.target.result;
        };

        reader.onerror = () => resolve(0);

        reader.readAsDataURL(file);
      });
    },
  };
};
